import { getRequest } from '../api-handler';
import { MethodDetailDto } from './method';

export const MethodApi = {
  getById: (id: number) => getRequest<MethodDetailDto>(`/methods/${id}`)
};
